"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchers = void 0;
var connected_react_router_1 = require("connected-react-router");
var toastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var reportsActions = require("@caddigital/sok-reducers/lib/actions/reports");
var mapDispatchers = function (dispatch) { return ({
    openFieldsModal: function (mode, type, reportUuid) {
        if (reportUuid === void 0) { reportUuid = null; }
        return dispatch(reportsActions.fieldsModalOpen({ mode: mode, reportUuid: reportUuid, type: type }));
    },
    removeReportsOrTemplates: function (removalPayload) {
        return dispatch(reportsActions.removeReportsRequest(removalPayload));
    },
    retrieveReport: function (uuid, type) {
        return dispatch(reportsActions.retrieveReportRequest(uuid, type));
    },
    showToast: function (_a) {
        var title = _a.title, message = _a.message, type = _a.type;
        return dispatch(toastActions.addNewToast(title, message, type));
    },
    clearExportReport: function () { return dispatch(reportsActions.clearExportReport()); },
    pushUrl: function (path) { return dispatch((0, connected_react_router_1.push)(path)); }
}); };
exports.mapDispatchers = mapDispatchers;
